// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Scoped Swiper core + cube effect styles for Storeeel only.
 * Swiper 公式 CSS から必要なルールのみを抜き出したもの。
 */
.storeeel-modal .swiper {
  margin-left: auto;
  margin-right: auto;
  position: relative;
  overflow: hidden;
  list-style: none;
  padding: 0;
  z-index: 1;
  display: block;
}

.storeeel-modal .swiper-vertical > .swiper-wrapper {
  flex-direction: column;
}

.storeeel-modal .swiper-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 1;
  display: flex;
  transition-property: transform;
  transition-timing-function: var(--swiper-wrapper-transition-timing-function, initial);
  box-sizing: content-box;
}

.storeeel-modal .swiper-android .swiper-slide,
.storeeel-modal .swiper-ios .swiper-slide,
.storeeel-modal .swiper-wrapper {
  transform: translate3d(0px, 0, 0);
}

.storeeel-modal .swiper-horizontal {
  touch-action: pan-y;
}

.storeeel-modal .swiper-vertical {
  touch-action: pan-x;
}

.storeeel-modal .swiper-slide {
  flex-shrink: 0;
  width: 100%;
  height: 100%;
  position: relative;
  transition-property: transform;
  display: block;
}

.storeeel-modal .swiper-slide-invisible-blank {
  visibility: hidden;
}

.storeeel-modal .swiper-backface-hidden .swiper-slide {
  transform: translateZ(0);
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}

/* 3D Effects (needed for cube) */
.storeeel-modal .swiper-3d .swiper-wrapper {
  transform-style: preserve-3d;
}

.storeeel-modal .swiper-3d {
  perspective: 1200px;
}

.storeeel-modal .swiper-3d .swiper-slide,
.storeeel-modal .swiper-3d .swiper-cube-shadow {
  transform-style: preserve-3d;
}

.storeeel-modal .swiper-3d .swiper-slide-shadow,
.storeeel-modal .swiper-3d .swiper-slide-shadow-left,
.storeeel-modal .swiper-3d .swiper-slide-shadow-right,
.storeeel-modal .swiper-3d .swiper-slide-shadow-top,
.storeeel-modal .swiper-3d .swiper-slide-shadow-bottom {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 10;
}

.storeeel-modal .swiper-3d .swiper-slide-shadow {
  background: rgba(0, 0, 0, 0.15);
}

.storeeel-modal .swiper-3d .swiper-slide-shadow-left {
  background-image: linear-gradient(to left, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
}

.storeeel-modal .swiper-3d .swiper-slide-shadow-right {
  background-image: linear-gradient(to right, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
}

.storeeel-modal .swiper-3d .swiper-slide-shadow-top {
  background-image: linear-gradient(to top, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
}

.storeeel-modal .swiper-3d .swiper-slide-shadow-bottom {
  background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
}

/* Cube effect */
.storeeel-modal .swiper.swiper-cube {
  overflow: visible;
}

.storeeel-modal .swiper-cube .swiper-slide {
  pointer-events: none;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  z-index: 1;
  visibility: hidden;
  transform-origin: 0 0;
  width: 100%;
  height: 100%;
}

.storeeel-modal .swiper-cube .swiper-slide .swiper-slide {
  pointer-events: none;
}

.storeeel-modal .swiper-cube.swiper-rtl .swiper-slide {
  transform-origin: 100% 0;
}

.storeeel-modal .swiper-cube .swiper-slide-active,
.storeeel-modal .swiper-cube .swiper-slide-active .swiper-slide-active {
  pointer-events: auto;
}

.storeeel-modal .swiper-cube .swiper-slide-active,
.storeeel-modal .swiper-cube .swiper-slide-next,
.storeeel-modal .swiper-cube .swiper-slide-prev {
  pointer-events: auto;
  visibility: visible;
}

.storeeel-modal .swiper-cube .swiper-cube-shadow {
  position: absolute;
  left: 0;
  bottom: 0px;
  width: 100%;
  height: 100%;
  opacity: 0.6;
  z-index: 0;
}

.storeeel-modal .swiper-cube .swiper-cube-shadow:before {
  content: '';
  background: #000;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  filter: blur(50px);
}

.storeeel-modal .swiper-cube .swiper-slide-next + .swiper-slide {
  pointer-events: auto;
  visibility: visible;
}

.storeeel-modal .swiper-cube .swiper-slide-shadow-cube.swiper-slide-shadow-top,
.storeeel-modal .swiper-cube .swiper-slide-shadow-cube.swiper-slide-shadow-bottom,
.storeeel-modal .swiper-cube .swiper-slide-shadow-cube.swiper-slide-shadow-left,
.storeeel-modal .swiper-cube .swiper-slide-shadow-cube.swiper-slide-shadow-right {
  z-index: 0;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}
`, "",{"version":3,"sources":["webpack://./src/styles/storeeel-swiper.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,aAAa;EACb,8BAA8B;EAC9B,qFAAqF;EACrF,uBAAuB;AACzB;;AAEA;;;EAGE,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA,iCAAiC;AACjC;EACE,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;;;;EAKE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gFAAgF;AAClF;;AAEA;EACE,iFAAiF;AACnF;;AAEA;EACE,+EAA+E;AACjF;;AAEA;EACE,kFAAkF;AACpF;;AAEA,gBAAgB;AAChB;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mCAAmC;EACnC,2BAA2B;EAC3B,UAAU;EACV,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;;;EAGE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,WAAW;EACX,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,SAAS;EACT,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;;;;EAIE,UAAU;EACV,mCAAmC;EACnC,2BAA2B;AAC7B","sourcesContent":["/*\n * Scoped Swiper core + cube effect styles for Storeeel only.\n * Swiper 公式 CSS から必要なルールのみを抜き出したもの。\n */\n.storeeel-modal .swiper {\n  margin-left: auto;\n  margin-right: auto;\n  position: relative;\n  overflow: hidden;\n  list-style: none;\n  padding: 0;\n  z-index: 1;\n  display: block;\n}\n\n.storeeel-modal .swiper-vertical > .swiper-wrapper {\n  flex-direction: column;\n}\n\n.storeeel-modal .swiper-wrapper {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n  display: flex;\n  transition-property: transform;\n  transition-timing-function: var(--swiper-wrapper-transition-timing-function, initial);\n  box-sizing: content-box;\n}\n\n.storeeel-modal .swiper-android .swiper-slide,\n.storeeel-modal .swiper-ios .swiper-slide,\n.storeeel-modal .swiper-wrapper {\n  transform: translate3d(0px, 0, 0);\n}\n\n.storeeel-modal .swiper-horizontal {\n  touch-action: pan-y;\n}\n\n.storeeel-modal .swiper-vertical {\n  touch-action: pan-x;\n}\n\n.storeeel-modal .swiper-slide {\n  flex-shrink: 0;\n  width: 100%;\n  height: 100%;\n  position: relative;\n  transition-property: transform;\n  display: block;\n}\n\n.storeeel-modal .swiper-slide-invisible-blank {\n  visibility: hidden;\n}\n\n.storeeel-modal .swiper-backface-hidden .swiper-slide {\n  transform: translateZ(0);\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n}\n\n/* 3D Effects (needed for cube) */\n.storeeel-modal .swiper-3d .swiper-wrapper {\n  transform-style: preserve-3d;\n}\n\n.storeeel-modal .swiper-3d {\n  perspective: 1200px;\n}\n\n.storeeel-modal .swiper-3d .swiper-slide,\n.storeeel-modal .swiper-3d .swiper-cube-shadow {\n  transform-style: preserve-3d;\n}\n\n.storeeel-modal .swiper-3d .swiper-slide-shadow,\n.storeeel-modal .swiper-3d .swiper-slide-shadow-left,\n.storeeel-modal .swiper-3d .swiper-slide-shadow-right,\n.storeeel-modal .swiper-3d .swiper-slide-shadow-top,\n.storeeel-modal .swiper-3d .swiper-slide-shadow-bottom {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n  z-index: 10;\n}\n\n.storeeel-modal .swiper-3d .swiper-slide-shadow {\n  background: rgba(0, 0, 0, 0.15);\n}\n\n.storeeel-modal .swiper-3d .swiper-slide-shadow-left {\n  background-image: linear-gradient(to left, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n}\n\n.storeeel-modal .swiper-3d .swiper-slide-shadow-right {\n  background-image: linear-gradient(to right, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n}\n\n.storeeel-modal .swiper-3d .swiper-slide-shadow-top {\n  background-image: linear-gradient(to top, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n}\n\n.storeeel-modal .swiper-3d .swiper-slide-shadow-bottom {\n  background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n}\n\n/* Cube effect */\n.storeeel-modal .swiper.swiper-cube {\n  overflow: visible;\n}\n\n.storeeel-modal .swiper-cube .swiper-slide {\n  pointer-events: none;\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n  z-index: 1;\n  visibility: hidden;\n  transform-origin: 0 0;\n  width: 100%;\n  height: 100%;\n}\n\n.storeeel-modal .swiper-cube .swiper-slide .swiper-slide {\n  pointer-events: none;\n}\n\n.storeeel-modal .swiper-cube.swiper-rtl .swiper-slide {\n  transform-origin: 100% 0;\n}\n\n.storeeel-modal .swiper-cube .swiper-slide-active,\n.storeeel-modal .swiper-cube .swiper-slide-active .swiper-slide-active {\n  pointer-events: auto;\n}\n\n.storeeel-modal .swiper-cube .swiper-slide-active,\n.storeeel-modal .swiper-cube .swiper-slide-next,\n.storeeel-modal .swiper-cube .swiper-slide-prev {\n  pointer-events: auto;\n  visibility: visible;\n}\n\n.storeeel-modal .swiper-cube .swiper-cube-shadow {\n  position: absolute;\n  left: 0;\n  bottom: 0px;\n  width: 100%;\n  height: 100%;\n  opacity: 0.6;\n  z-index: 0;\n}\n\n.storeeel-modal .swiper-cube .swiper-cube-shadow:before {\n  content: '';\n  background: #000;\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  filter: blur(50px);\n}\n\n.storeeel-modal .swiper-cube .swiper-slide-next + .swiper-slide {\n  pointer-events: auto;\n  visibility: visible;\n}\n\n.storeeel-modal .swiper-cube .swiper-slide-shadow-cube.swiper-slide-shadow-top,\n.storeeel-modal .swiper-cube .swiper-slide-shadow-cube.swiper-slide-shadow-bottom,\n.storeeel-modal .swiper-cube .swiper-slide-shadow-cube.swiper-slide-shadow-left,\n.storeeel-modal .swiper-cube .swiper-slide-shadow-cube.swiper-slide-shadow-right {\n  z-index: 0;\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
